import { render, staticRenderFns } from "./MapA.vue?vue&type=template&id=36b4d9fa"
import script from "./MapA.vue?vue&type=script&lang=js"
export * from "./MapA.vue?vue&type=script&lang=js"
import style0 from "./MapA.vue?vue&type=style&index=0&id=36b4d9fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VImg})
